import { ROLES } from 'src/constants/roles';

export const getWorkspaceSelectionPath = () => '/workspaces';

export const hasWorkspaceAccess = user => {
  if (!user) {
    return false;
  }

  if (user.role === ROLES.superAdmin) {
    return true;
  }

  return (user.workspaces || []).length > 0;
};

export const getPostLoginPath = user => {
  const workspaces = user?.workspaces || [];

  if (!user) {
    return '/login';
  }

  if (user.role === ROLES.superAdmin) {
    return '/super-admin';
  }

  if (!hasWorkspaceAccess(user)) {
    return '/login';
  }

  if (workspaces.length > 1) {
    return getWorkspaceSelectionPath();
  }

  if (workspaces.length === 1) {
    return `/admin/${workspaces[0].id}/bots`;
  }

  return '/login';
};
